/**
 * Seeds a local auth session for MSW / Playwright mock mode.
 *
 * Real OAuth `/authorize` is a full-page navigation that MSW cannot intercept.
 * Mock mode therefore plants the same cookie + localStorage keys that a
 * successful OAuth exchange would leave behind.
 */

import { AUTH_TOKEN_COOKIE_NAME, OAUTH_TOKEN_KEYS, USER_ID_KEY } from "./types"

export const MOCK_AUTH_USER_ID = "user-001"
export const MOCK_AUTH_JWT = "mock-jwt-token"
export const MOCK_AUTH_ACCESS_TOKEN = "mock-access-token"
export const MOCK_AUTH_REFRESH_TOKEN = "mock-refresh-token"

export function seedMockAuthSession(): void {
	if (typeof window === "undefined") {
		return
	}

	// No Secure flag — local Vite runs on http://localhost
	// biome-ignore lint/suspicious/noDocumentCookie: mock session must set host-only JWT cookie
	document.cookie = `${AUTH_TOKEN_COOKIE_NAME}=${MOCK_AUTH_JWT}; path=/`
	localStorage.setItem(OAUTH_TOKEN_KEYS.ACCESS_TOKEN, MOCK_AUTH_ACCESS_TOKEN)
	localStorage.setItem(OAUTH_TOKEN_KEYS.REFRESH_TOKEN, MOCK_AUTH_REFRESH_TOKEN)
	localStorage.setItem(USER_ID_KEY, MOCK_AUTH_USER_ID)
}
